import React from "react";
import { TableCell, TableHead, TableRow, styled } from "@mui/material";


export default function VisaOptionHead() {

    const VisaOptionHeadText = styled(TableCell)(
        ({ theme }) => `
            font-size: ${theme.typography.tableHeads.fontSize} !important;
            font-weight: bold;
            text-align: center;
        `
    )

    return (
        <TableHead sx={{background: "#F4F4F0"}}>
            <TableRow>
                <VisaOptionHeadText>نوع ویزا</VisaOptionHeadText>
                <VisaOptionHeadText>امکان دریافت ویزا</VisaOptionHeadText>
                {/* <VisaOptionHeadText>Coveats</VisaOptionHeadText> */}
                {/* <VisaOptionHeadText>Legiative</VisaOptionHeadText> */}
                {/* <VisaOptionHeadText>لیست بلند مدت</VisaOptionHeadText>
                <VisaOptionHeadText>لیست کوتاه مدت</VisaOptionHeadText> */}
                {/* <VisaOptionHeadText>ROL</VisaOptionHeadText> */}
            </TableRow>
        </TableHead>
    );
  }